import request from '../../axios';
import {BasketResponse} from './types';

export const getBasket = async () => {
  const {data}: {data: BasketResponse[]} = await request.get(
    `/api/v2/order/basket`,
  );

  return data;
};
